exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".posglobal-spinner-backdrop[data-v-406f6d9e]{position:fixed;width:100%;height:100%;top:0;left:0;z-index:1000;background:hsla(0,0%,100%,.85)}.spinner-border[data-v-406f6d9e]{position:absolute;top:calc(50% - 20px);left:calc(50% - 20px)}", ""]);

// exports
